import React                     from 'react';
import styled                    from 'styled-components';
import { TDataTableRow }         from '@typings/components';
import { DataTable }             from '@components/DataTable/DataTable';
import { REPORTS_TABLE_HEADERS } from '@modules/accountManagement/utils/tableHeaders';

const Wrapper = styled.div`
  width: 60%;
`;

interface IProps {
  tableRows: TDataTableRow[];
}

export const ReportsPage = ({ tableRows }: IProps) => (
  <Wrapper>
    <DataTable
      headers = {REPORTS_TABLE_HEADERS}
      rows    = {tableRows}
      margin  = "20px 30px"
    />
  </Wrapper>
);
